// extracted by mini-css-extract-plugin
export var deliveryRow = "_mt-a";
export var fixedHeight = "_mt-4";
export var freightLogo = "_mt-9";
export var fullWidth = "_mt-3";
export var priceColumn = "_mt-5";
export var radioSelected = "_mt-7";
export var radioUnselected = "_mt-6";
export var selectedOption = "_mt-2";
export var selectedOptionContainer = "_mt-1";
export var selection = "_mt-0";
export var tallSkeletonText = "_mt-8";